@if (isLoading) {
    <loading [isLoading]="isLoading" [success]="true"></loading>
} @else {
    <div class="flex flex-col gap-4">
        <div class="text-sm flex flex-col gap-2">
            <p>View all current and past subscriptions. Your account can be upgraded, or downgraded, at any time.</p>
            <p>To see available subscriptions view the <a href="/account/upgrade" class="text-ponder-link hover:text-ponder-linkhover">Account Upgrade page</a>.</p>
        </div>
        <div class="flex flex-col gap-2 p-2 text-sm rounded-md">
            @if (subscriptions.length) {
                    <div class="flex flex-row gap-2 font-bold items-center text-center">
                        <div class="w-[4ch]">

                        </div>
                        <div class="w-[24ch] text-left">
                            Product
                        </div>
                        <div class="w-[8ch]">
                            Status
                        </div>
                        <div class="grow">
                            Actions
                        </div>
                    </div>
                @for (subscription of subscriptions ; track subscription.id) {
                    <user-subscription-row [subscription]="subscription"></user-subscription-row>
                }
            } @else {
                <div class="text-slate-400 text-center italic text:xs sm:text-sm">
                    You have no subscription history.
                </div>
            }
        </div>
    </div>
}
